export const LAST_MINUTE_PRODUCT_NAME = 'Last Minute Escapes'
export const LAST_MINUTE_PRODUCT_CODE = 'lastMinute'
export const LAST_MINUTE_LABEL_ID = '2ne0nnfbal87aj5cs98n'
